import { useSelector } from "react-redux";
import { usePolls } from "../../../../../../hooks/use-polls";
import { selectBroadcastId } from "../../../../../../redux/broadcast/broadcast.selectors";
import Poll from "../../components/poll/poll";

import * as SharedCSS from "../../polls-module.styles";

const ActivePolls = () => {
	const broadcastId = useSelector(selectBroadcastId);
	const polls = usePolls(broadcastId);

	const activePolls = polls.filter((poll) => !poll.ended);

	return (
		<SharedCSS.PollList>
			{activePolls.map((poll) => (
				<Poll key={poll.id} poll={poll} />
			))}
		</SharedCSS.PollList>
	);
};

export default ActivePolls;
